var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSalaryQuestion)?_c('salary-open-card',{attrs:{"question":_vm.question}}):_c('variable-open-card',{attrs:{"question":_vm.question}})}
var staticRenderFns = []

export { render, staticRenderFns }